const handleDateFilterChange = (filter) => {
  if (typeof filter === "object" && (filter.start || filter.end)) {
    const startDate = filter.start ? new Date(filter.start) : null
    const endDate = filter.end ? new Date(filter.end) : startDate

    return ({ start: startDate, end: endDate })
  }

  let startDate
  let endDate

  const today = new Date()
  switch (filter) {
    case "7 last days":
      startDate = new Date(today)
      startDate.setDate(today.getDate() - 7)
      endDate = today
      break
    case "Current Month":
      startDate = new Date(today.getFullYear(), today.getMonth(), 1)
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      break
    case "Last Month":
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      endDate = new Date(today.getFullYear(), today.getMonth(), 0)
      break
    case "Current Year":
      startDate = new Date(today.getFullYear(), 0, 1)
      endDate = new Date(today.getFullYear(), 11, 31)
      break
    case "Last Year":
      startDate = new Date(today.getFullYear() - 1, 0, 1)
      endDate = new Date(today.getFullYear() - 1, 11, 31)
      break
    default:
      startDate = null
      endDate = null
  }
  return ({ start: startDate, end: endDate })
}

export default handleDateFilterChange
